import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import type { Option } from '@sequencehq/core-components'

type Contact =
  Dashboardv99990101Api.GetCustomer.GetCustomerResponse['contacts'][number]

export const contactsToOptions = (
  contacts: Array<Contact>,
  disabled: (contact: Contact) => boolean = () => false
): Option[] =>
  contacts.map(contact => ({
    label: contact.name ?? contact.email,
    secondaryLabel: contact.name ? contact.email : undefined,
    value: contact.id,
    disabled: disabled(contact)
  }))
